module.exports = "/packs/013-fa4f16522a15955c07f7d7dd8a9c28df.jpg";